import Animation from 'Scripts/classes/Animation'
//Vendors
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
import { deviceType } from 'Scripts/utils/utils'

export default class extends Animation {
  constructor({ scroller, element, elements }) {
    super({ element, elements })
    //
    this.scroller = scroller
    this.elements = elements
    //
    this.onResize()
    this.length = this.elements.items.length
    this.gap = parseInt(window.getComputedStyle(this.elements.list).getPropertyValue('grid-row-gap'))
    // 
    this.device = deviceType()
    this.mobile = this.device === 'mobile'
    //
    // if( this.device  === 'desktop') this.init()
    this.init()

  }


  init() {
    this.tl = gsap.timeline({ paused: false })
    //background pin
    ScrollTrigger.create({
      trigger: '.histoire__bg_wrapper',
      pin: true,
      pinSpacing: false,
      start: 'top top',
      end: `${this.elements.list.clientHeight + this.screen.width / 2} center`,
      markers: false,
    })

    //date pin
    this.elements.dates?.forEach((date, index) => {
      // gsap.set(date, { autoAlpha: 0 })
      // gsap.set(this.elements.bg[index], { autoAlpha: 0 })
      ScrollTrigger.create({
        trigger: date,
        start: 'center center',
        end: `${this.elements.items[index].clientHeight + this.getMargin(index)} center`,
        // end: () => {
        //   if (index === this.length - 1) return 'top center'
        //   else return `${this.elements.items[index].clientHeight + this.getMargin(index)} center`
        // },        
        onToggle: self => {
          self.isActive ? this.onEnter(date, index) : this.onLeave(date, index)
          // self.isActive && this.onEnter(date, index)
        },
        pin: !this.mobile,
        pinSpacing: false,
        scrub: 10,
        markers: false,
        anticipatePin: 1,//To resolve pin jumping
        preventOverlaps: true,
        fastScrollEnd: false

      })
    })

  }

  onEnter(date, index) {

    // this.elements.items.forEach((item, i) => {
    //   if (i === index) {
    //     gsap.to(item.lastElementChild, { opacity: 1 })
    //     gsap.to(this.elements.bg[i], { autoAlpha: 0.25 })
    //     gsap.to(date, { autoAlpha: 1, duration: 1 })
    //   } else {
    //     gsap.to(item.lastElementChild, { opacity: 0.25 })
    //     gsap.to(this.elements.bg[i], { autoAlpha: 0 })
    //     gsap.to(this.elements.dates[i], { autoAlpha: 0 })

    //   }
    // })


    // if (this.isBgAnimating) return
    // this.isBgAnimating = true
    // this.elements.bg.forEach((item, i) => {
    //   if (i === index) {
    //     gsap.to(item, { autoAlpha: 0.25 })
    //   } else {
    //     gsap.to(item, { autoAlpha: 0 })
    //   }

    //   if (i === this.length - 1) this.isBgAnimating = false
    // })

    // this.tl.to(date, { autoAlpha: 1 })
    // this.tl.to(this.elements.bg[index], { autoAlpha: 1, duration: 1 })
    // this.tl.to(this.elements.items[index].lastElementChild, { opacity: 1 })

    gsap.to(this.elements.items[index].lastElementChild, { opacity: 1 })
    gsap.to(date, { autoAlpha: 1 })
    gsap.to(this.elements.bg[index], { autoAlpha: .25 })
  }

  onLeave(date, index) {
    gsap.to(this.elements.items[index].lastElementChild, { opacity: 0.25 })
    gsap.to(this.elements.bg[index], { autoAlpha: 0 })
    gsap.to(date, { autoAlpha: 0 })
  }

  getMargin(index) {
    // return index < this.elements.items.length - 1 ? this.gap : 0       
    return index < this.elements.items.length - 1 ? this.gap : this.gap / 2

  }

  animateIn() {
    super.animateIn()
    this.addEventListeners()
  }

  animateOut() {
    super.animateOut()
    this.removeEventListeners()

  }


  addEventListeners() {
    window.addEventListener('resize', this.onResize.bind(this))
  }

  removeEventListeners() {
    window.removeEventListener('resize', this.onResize.bind(this))
  }

  onResize() {
    this.screen = {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }
}